import { useParams } from "react-router-dom";
import { ContactDetailsContainer } from "./contact-details/ContactDetailsContainer";
import { ContactDetailsProvider } from "./contact-details/ContactDetailsProvider";
import { Spinner } from "@/components/ui/spinner";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useContactDetails } from "./contact-details/ContactDetailsProvider";

const ContactDetailsContent = () => {
  const { profile, loading, error } = useContactDetails();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-2xl mx-auto p-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            {error.message || "Error loading contact details"}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="max-w-2xl mx-auto p-8">
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Contact Not Found</AlertTitle>
          <AlertDescription>
            The requested contact could not be found. It may have been deleted or you might not have permission to view it.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <>
      <ContactDetailsContainer />
    </>
  );
};

export const ContactDetails = () => {
  const { id } = useParams<{ id: string }>();
  
  if (!id) {
    return (
      <div className="max-w-2xl mx-auto p-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            No contact ID provided
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <ContactDetailsProvider contactId={id}>
      <ContactDetailsContent />
    </ContactDetailsProvider>
  );
};